"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global SnhuFetchUtil */
/* global ThankYouCookie */
/* global EcommerceCookie */
/* global FormSubmitCookie */

var forms = function () {
  var invalidclass = "invalid-feedback";
  var errorelementclass = "error";
  var invalidElementclass = "invalidElement";
  var validElementclass = "validElement";
  var validFormGroup = "valid-form-group";
  var validSelectElement = "valid-multi-col-select";
  var dobMinimumAge = 16;
  var dobNotOldEnoughMessage = "You must be at least " + dobMinimumAge + " years old to attend SNHU";
  var dobAutoCompleteValue = "bday";

  // ***Remove validtion of cascading dropdowns ***
  function _removeValidation(id) {
    var ele = document.getElementById(id);
    var wrap = ele.closest('div.form-group');
    wrap.classList.remove(validFormGroup);
    wrap.classList.remove(validSelectElement);
    ele.classList.remove(validElementclass);
    var errorcontainer = wrap.querySelector('span.' + errorelementclass);
    errorcontainer.textContent = '';
    errorcontainer.classList.remove(invalidclass);
    ele.classList.remove(invalidElementclass);
  }

  // ***VALID Element ***
  function _elementValid(ele) {
    //get the wrapping div
    var wrap = ele.closest('div.form-group');

    //get the error container
    var errorcontainer = wrap.querySelector('span.' + errorelementclass);
    if (errorcontainer !== null) {
      errorcontainer.textContent = '';
      errorcontainer.classList.remove(invalidclass);
      ele.classList.remove(invalidElementclass);
      ele.classList.add(validElementclass);
      if (ele.required && !(ele.type === 'checkbox' || ele.type === 'radio')) {
        wrap.classList.add(validFormGroup);
        if (ele.type === 'select-one') {
          wrap.classList.add(validSelectElement);
        }
      }
    }
  }

  // ***NOT VALID Element ***
  function _elementInvalid(ele) {
    var overrideMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    //get the wrapping div
    var wrap = ele.closest('div.form-group');
    var patternMessage = 'Invalid data \n';
    var requiredMessage = '';
    var fieldlabel = '';
    if (ele.hasAttribute('placeholder')) {
      fieldlabel = ele.getAttribute('placeholder');
    } else if (wrap.querySelector('label') !== null) {
      fieldlabel = wrap.querySelector("label").textContent;
    }
    if (ele.hasAttribute('data-invalidRequired')) {
      requiredMessage = ele.getAttribute('data-invalidRequired') + '\n';
    } else if (ele.hasAttribute('required')) {
      //add onto the invalid message
      requiredMessage = fieldlabel + ' is required. \n';
    } else {
      requiredMessage = fieldlabel + ' is required.';
    }
    if (ele.hasAttribute('data-invalidPattern')) {
      patternMessage = ele.getAttribute('data-invalidPattern') + '\n';
    }
    var errorMessage = requiredMessage;
    //get the error container
    var errorcontainer = wrap.querySelector('span.' + errorelementclass);

    //add onto the invalid message
    if (ele.validity.badInput || ele.validity.patternMismatch || ele.validity.tooShort || ele.validity.tooLong || ele.validity.rangeUnderflow || ele.validity.rangeOverflow) {
      errorMessage = patternMessage;
    }
    errorcontainer.textContent = overrideMessage !== '' ? overrideMessage : errorMessage;
    errorcontainer.classList.add(invalidclass);
    ele.classList.remove(validElementclass);
    ele.classList.add(invalidElementclass);
    if (ele.required && !(ele.type === 'checkbox' || ele.type === 'radio')) {
      wrap.classList.remove(validFormGroup);
      wrap.classList.remove(validSelectElement);
    }
    return errorMessage;
  }

  // ***CHECKBOX/RADIO Validation ***
  function _checkboxValidity(ele) {
    var wrap = ele.closest('div.form-group');
    var fieldset = wrap.querySelector('fieldset');
    var errorMessage = '';
    var elementgroup = fieldset !== null ? fieldset.querySelectorAll('input') : null;
    if (fieldset !== null && elementgroup.length > 1) {
      var isValid = false;
      elementgroup.forEach(function (cbox) {
        if (cbox.checked) {
          isValid = true;
        }
      });
      if (isValid) {
        _elementValid(ele);
        elementgroup.forEach(function (cbox) {
          cbox.classList.remove(invalidElementclass);
          cbox.classList.add(validElementclass);
        });
      } else {
        errorMessage = _elementInvalid(ele);
        elementgroup.forEach(function (cbox) {
          cbox.classList.remove(validElementclass);
          cbox.classList.add(invalidElementclass);
        });
      }
    } else {
      //is a single check box - check validity and be done
      if (ele.validity.valid) {
        _elementValid(ele);
      } else {
        errorMessage = _elementInvalid(ele);
      }
    }
    return errorMessage;
  }
  function _checkInputLabels(form) {
    var tForm = form;
    tForm.querySelectorAll('input').forEach(function (ele) {
      if (ele.type === 'text' || ele.type === 'tel' || ele.type === 'email') {
        if (ele.value.length > 0) {
          if (ele.validity.valid) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        }
      }
    });
    tForm.querySelectorAll('textarea').forEach(function (ele) {
      if (ele.value.length > 0) {
        if (ele.validity.valid) {
          _elementValid(ele);
        } else {
          _elementInvalid(ele);
        }
      }
    });
  }
  function _validateDateOfBirth(dateOfBirth) {
    if (dateOfBirth) {
      var dob = new Date(dateOfBirth);
      var maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() - dobMinimumAge);
      if (dob <= maxDate) {
        return true;
      }
    }
    return false;
  }

  // ***ELEMENT inline validation ***
  function _addElementValidation(form) {
    var tForm = form;
    if (tForm.dataset.noelementvalidation !== "true") {
      tForm.querySelectorAll('input:not([type="hidden"]):not([data="hpfield"])').forEach(function (ele) {
        ele.addEventListener('input', function () {
          if ((ele.type === 'checkbox' || ele.type === 'radio') && ele.hasAttribute('required')) {
            //extra checking for checkboxes to determine if group
            _checkboxValidity(ele);
          } else if (ele.autocomplete === dobAutoCompleteValue) {
            if (!ele.validity.valid) {
              _elementInvalid(ele);
            } else if (!_validateDateOfBirth(ele.value)) {
              _elementInvalid(ele, dobNotOldEnoughMessage);
            } else {
              _elementValid(ele);
            }
          } else if (ele.validity.valid) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        });
        ele.addEventListener('blur', function () {
          if ((ele.type === 'checkbox' || ele.type === 'radio') && ele.hasAttribute('required')) {
            //extra checking for checkboxes to determine if group
            _checkboxValidity(ele);
          } else if (ele.autocomplete === dobAutoCompleteValue) {
            if (!ele.validity.valid) {
              _elementInvalid(ele);
            } else if (!_validateDateOfBirth(ele.value)) {
              _elementInvalid(ele, dobNotOldEnoughMessage);
            } else {
              _elementValid(ele);
            }
          } else if (ele.validity.valid) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        });
      });
      tForm.querySelectorAll('select').forEach(function (ele) {
        ele.addEventListener('input', function () {
          if (ele.checkValidity() && (!ele.hasAttribute('required') || ele.hasAttribute('required') && ele.options[ele.selectedIndex].value !== '')) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        });
        ele.addEventListener('blur', function () {
          if (ele.checkValidity() && (!ele.hasAttribute('required') || ele.hasAttribute('required') && ele.options[ele.selectedIndex].value !== '')) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        });
      });
      tForm.querySelectorAll('textarea').forEach(function (ele) {
        ele.addEventListener('input', function () {
          if (ele.validity.valid) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        });
        ele.addEventListener('blur', function () {
          if (ele.validity.valid) {
            _elementValid(ele);
          } else {
            _elementInvalid(ele);
          }
        });
      });
    }
  }

  // ***FORM SUBMIT VALID FORM ***
  function _submitValidatedForm(form, submitter, submitterText) {
    var formData = new FormData(form);
    var action = form.getAttribute("action");
    var errormsg = "\n";
    var fetcher = new SnhuFetchUtil({
      defaultTimeout: 11000
    });
    fetcher.post(action, formData).then(function (data) {
      if (!data.success) {
        if (data.errors !== undefined && data.errors !== null) {
          for (var _i = 0, _Object$entries = Object.entries(data.errors); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];
            errormsg += "\n" + value;
            var ele = document.getElementsByName(key);
            if (ele.length > 0) {
              if (ele[0].type === 'checkbox' || ele[0].type === 'radio') {
                _checkboxValidity(ele[0]);
              } else {
                _elementInvalid(ele[0]);
              }
            }
          }
        }
        if (submitter !== null) {
          submitter.innerHTML = submitterText;
          submitter.disabled = false;
        }
        alert('Form submit failed. Try again.' + errormsg); /* eslint-disable-line no-alert */
      } else {
        //set the thankYouPage here in case we error. We still want to send to TY page if there is an error
        var thankYouPage = data.thankyoupage;

        //if there's no thank you page defined, set it to the generic one
        if (!thankYouPage) {
          thankYouPage = window.location.origin + '/thankyou';
        }
        Promise.all([ThankYouCookie.storeThankYouValues(form, data), EcommerceCookie.setEcommerceCookie(data), FormSubmitCookie.setFormSubmitCookie(form, data)]).catch(function () {
          window.location.replace(thankYouPage);
        }).finally(function () {
          window.location.replace(thankYouPage);
        });
      }
      return data;
    }).catch(function () {
      var errorTYP = document.getElementById('errorTYP') ? document.getElementById('errorTYP').textContent : null;
      if (errorTYP !== null && errorTYP !== '') {
        window.location.replace(errorTYP);
      } else {
        alert('Sorry, there has been an error with this page. Please try again later or call 888.387.0864 for assistance.'); /* eslint-disable-line no-alert */

        if (submitter !== null) {
          submitter.innerHTML = submitterText;
          submitter.disabled = false;
        }
      }
    });
  }

  //validate all fields in the form
  //pass the form or object to be validated
  function _validateFormFields(form) {
    var tForm = form;
    var te = "";
    var entireError = "";
    var isValidForm = true;
    tForm.querySelectorAll('span.error.invalid-feedback').forEach(function (ele) {
      if (ele.offsetParent !== null && ele.nextSibling === null && ele.previousSibling === null && ele.offsetParent.id !== 'prevCollege') {
        isValidForm = false;
        entireError += ele.textContent + '\n';
      }
    });
    tForm.querySelectorAll('input:not([type="hidden"]):not([data="hpfield"]):not([disabled])').forEach(function (ele) {
      if (ele.hasAttribute('required')) {
        if (ele.type === 'checkbox' || ele.type === 'radio') {
          //extra checking for checkboxes to determine if group
          if (ele.offsetParent !== null) {
            te = _checkboxValidity(ele);
            if (entireError.indexOf(te) < 0) {
              entireError += te;
              isValidForm = false;
            }
          }
        } else if (ele.validity.valid) {
          _elementValid(ele);
        } else {
          if (ele.offsetParent !== null) {
            isValidForm = false;
            te = _elementInvalid(ele);
            if (entireError.indexOf(te) < 0) {
              entireError += te;
            }
          }
        }
      }

      // hardcoded holiday and weekend validation for visit form
      if (ele.hasAttribute('data-weekday-picker') && ele.value !== '' && ele.offsetParent !== null) {
        var filterDateEle = document.querySelector('[data-weekday-dates]'); //hidden element with the dates
        var filterDates = filterDateEle.value; // list of holidays and other closed dates
        var dateErrorMsg = filterDateEle.dataset.errorMsg; // error message

        // check against the list of dates
        if (filterDates !== null) {
          if (filterDates.includes(ele.value)) {
            _elementInvalid(ele);
            entireError += dateErrorMsg + ' \n';
            isValidForm = false;
          }
        }

        // check weekends
        var dt = new Date(ele.value);
        var sunday = 0;
        var saturday = 6;
        if (dt.getDay() === sunday || dt.getDay() === saturday) {
          _elementInvalid(ele);
          entireError += dateErrorMsg + ' \n';
          isValidForm = false;
        }

        // check past dates
        if (dt < new Date()) {
          _elementInvalid(ele);
          entireError += dateErrorMsg + ' \n';
          isValidForm = false;
        }
      }

      //date of birth field validation
      if (ele.autocomplete === dobAutoCompleteValue) {
        if (!_validateDateOfBirth(ele.value)) {
          _elementInvalid(ele, dobNotOldEnoughMessage);
          entireError += dobNotOldEnoughMessage + ' \n';
          isValidForm = false;
        }
      }
    });
    tForm.querySelectorAll('select').forEach(function (ele) {
      if (ele.checkValidity() && (!ele.hasAttribute('required') || ele.hasAttribute('required') && ele.options[ele.selectedIndex].value !== '')) {
        _elementValid(ele);
      } else if (ele.offsetParent !== null) {
        isValidForm = false;
        entireError += _elementInvalid(ele);
      }
    });
    tForm.querySelectorAll('textarea:not([disabled])').forEach(function (ele) {
      if (ele.validity.valid) {
        _elementValid(ele);
      } else if (ele.offsetParent !== null) {
        isValidForm = false;
        entireError += _elementInvalid(ele);
      }
    });
    return {
      "isValidForm": isValidForm,
      "Message": entireError
    };
  }

  // ***FORM inline validation ***
  function _addFormValidation(form) {
    var tForm = form;
    tForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var isValidForm = true;
      var entireError = "";
      var submitter = tForm.querySelector('button[type="submit"]');
      var submitterText = submitter.firstChild.nodeValue;
      submitter.disabled = true;
      submitter.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
      var formValidator = _validateFormFields(tForm);
      isValidForm = formValidator.isValidForm;
      entireError = formValidator.Message;
      if (isValidForm) {
        _submitValidatedForm(tForm, submitter, submitterText);
      } else {
        submitter.innerHTML = submitterText;
        submitter.disabled = false;
        alert(entireError + '\n'); /* eslint-disable-line no-alert */
      }
    });
  }

  // ***Validate element by ID***
  function _validateElementById(id) {
    var ele = document.getElementById(id);
    if (ele) {
      if (ele.type === 'select-one') {
        if (ele.checkValidity() && (!ele.hasAttribute('required') || ele.hasAttribute('required') && ele.options[ele.selectedIndex].value !== '')) {
          _elementValid(ele);
        } else {
          _elementInvalid(ele);
        }
      }
      if (ele.type === 'text') {
        if (ele.checkValidity()) {
          _elementValid(ele);
        } else {
          _elementInvalid(ele);
        }
      }
    }
  }
  function _validateCascade(location, degree, category, expAch, country) {
    var allValid = true;
    if (location !== "" && document.getElementById(location).value !== "") {
      _validateElementById(location);
    } else {
      allValid = false;
    }
    if (degree !== "" && document.getElementById(degree).value !== "") {
      _validateElementById(degree);
    } else {
      allValid = false;
    }
    if (category !== "" && document.getElementById(category).value !== "") {
      _validateElementById(category);
    } else {
      allValid = false;
    }
    if (expAch !== "" && document.getElementById(expAch).value !== "") {
      _validateElementById(expAch);
    } else {
      allValid = false;
    }
    if (country !== "" && document.getElementById(country).value !== "") {
      _validateElementById(country);
    }
    return allValid;
  }
  function _hideField(id) {
    var ele = document.getElementById(id);
    var wrap = ele.closest('div.form-group');
    wrap.style.display = "none";
  }
  return {
    elementValid: _elementValid,
    checkboxValidity: _checkboxValidity,
    checkInputLabels: _checkInputLabels,
    validateDateOfBirth: _validateDateOfBirth,
    addElementValidation: _addElementValidation,
    submitValidatedForm: _submitValidatedForm,
    addFormValidation: _addFormValidation,
    validateElementById: _validateElementById,
    hideField: _hideField,
    validateFormFields: _validateFormFields,
    removeValidation: _removeValidation,
    validateCascade: _validateCascade
  };
}();
if (typeof exports !== 'undefined') {
  module.exports = forms;
}
window.addEventListener('load', function () {
  document.querySelectorAll('form:not([data-novalidation="true"])').forEach(function (form) {
    //move labels on back button
    forms.addElementValidation(form);
    forms.addFormValidation(form);
    window.addEventListener('load', function () {
      forms.checkInputLabels(form);
    });
  });
});
/* global CookieProvider */
var FormUtilities = /*#__PURE__*/function () {
  function FormUtilities(form) {
    _classCallCheck(this, FormUtilities);
    this.form = form;
  }
  return _createClass(FormUtilities, [{
    key: "getFormType",
    value: function getFormType() {
      if (!this.form || !this.form.dataset) {
        return '';
      }
      var dataFormType = this.form.dataset.formtype;

      /* eslint-disable indent */
      /* eslint-disable no-nested-ternary */
      return !dataFormType ? '' : dataFormType.indexOf('app') > 0 ? 'app' : dataFormType.indexOf('inq') > 0 ? 'inq' : dataFormType;
      /* eslint-enable indent */
      /* eslint-disable no-nested-ternary */
    }
  }, {
    key: "getFormSource",
    value: function getFormSource(snhuCookieProvider) {
      if (!this.form) {
        return '';
      }

      /* istanbul ignore next*/
      var snhuEconCookie = snhuCookieProvider || new CookieProvider();

      // The cookie name - 'snhuEconTrasation' - is
      // intentionally spelled incorrectly here.
      var cookieVals = snhuEconCookie.getValueAsJson("snhuEconTransation");
      return cookieVals && cookieVals.formsource ? cookieVals.formsource : '';
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "isPrepopulated",
    value: function isPrepopulated(snhuCookieProvider) {
      if (!this.form) {
        return false;
      }

      /* istanbul ignore next*/
      var snhuProgramCookie = snhuCookieProvider || new CookieProvider();
      return snhuProgramCookie.getValueAsString("SNHUProgramId") ? true : false;
    }
  }]);
}();
/* istanbul ignore next*/
if (typeof exports !== 'undefined') {
  module.exports = FormUtilities;
}
/**
 * Source code adapted from: https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/examples/radio/js/radio.js
 */
(function () {
  var groupSelector = 'fieldset';
  var buttonSelector = '[type=radio]';

  /*
  * @function setRadioButton
  *
  * @desc Toogles the state of a radio button
  *
  * @param   {Object}  event  -  Standard W3C event object
  *
  */
  function setRadioButton(node, state) {
    if (state) {
      node.tabIndex = 0;
    } else {
      node.tabIndex = -1;
    }
    node.checked = state;
  }

  /*
  * @function keyDownRadioGroup
  *
  * @desc
  *
  * @param   {Object}   node  -  DOM node of updated group radio buttons
  */
  function keyDownRadioGroup(event) {
    var type = event.type;
    if (type === "keydown") {
      var node = event.currentTarget;
      var next = false;
      var spaceKeyCode = 'Space';
      switch (event.key) {
        case 'Spacebar':
          next = node;
          break;
        default:
          if (event.code === spaceKeyCode) {
            next = node;
            break;
          } else {
            next = false;
          }
      }
      if (next) {
        var radiogroup = node.parentElement.parentElement.querySelectorAll(buttonSelector);
        for (var i = 0; i < radiogroup.length; i++) {
          setRadioButton(radiogroup[i], radiogroup[i] === next);
          if (radiogroup[i] === next) {
            radiogroup[i].focus();
          }
        }
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  /*
  * @function focusRadioButton
  *
  * @desc Adds focus styling to label element encapsulating standard radio button
  *
  * @param   {Object}  event  -  Standard W3C event object
  */
  function focusRadioButton(event) {
    // If focused radio is not checked
    if (!event.currentTarget.checked) {
      var radiogroup = event.currentTarget.closest(groupSelector).querySelectorAll(buttonSelector);
      for (var i = 0; i < radiogroup.length; i++) {
        if (radiogroup[i] === event.currentTarget) {
          radiogroup[i].tabIndex = 0;
        } else {
          setRadioButton(radiogroup[i], false);
        }
      }
    }
  }

  /*
  * @function clickRadioGroup
  *
  * @desc
  *
  * @param   {Object}  node  -  DOM node of updated group radio buttons
  */

  function clickRadioButton(event) {
    if (event.type === 'click') {
      var radiogroup = event.currentTarget.closest(groupSelector).querySelectorAll(buttonSelector);
      for (var i = 0; i < radiogroup.length; i++) {
        setRadioButton(radiogroup[i], radiogroup[i] === event.currentTarget);
        if (radiogroup[i] === event.currentTarget) {
          radiogroup[i].focus();
        }
      }
    }
  }
  window.addEventListener('load', function () {
    var radiobuttons = document.querySelectorAll(buttonSelector);
    for (var i = 0; i < radiobuttons.length; i++) {
      var rb = radiobuttons[i];
      rb.addEventListener('keydown', keyDownRadioGroup);
      rb.addEventListener('focus', focusRadioButton);
      rb.addEventListener('click', clickRadioButton);
      var firstRadio = rb.closest(groupSelector).querySelector(buttonSelector);
      if (rb !== firstRadio && rb.checked) {
        // For radio buttons checked on page load that are not the first item
        rb.tabIndex = 0;
        firstRadio.tabIndex = -1;
      } else if (rb !== firstRadio) {
        rb.tabIndex = -1;
      }
    }
  });
})();

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function serialize(form) {
  /*eslint-disable-line no-unused-vars*/

  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
      continue;
    }

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) {
          continue;
        }
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    } else if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
      /*eslint-disable-line no-extra-parens*/ // Convert field data to a query string
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }
  return serialized.join('&');
};
if (typeof exports !== 'undefined') {
  module.exports = serialize;
}
/**
 * Used to control the display of the spin wheel native to iOS devices with small screen widths
 */
var SpinWheelController = /*#__PURE__*/function () {
  /**
   * Constructor SpinWheelController
   */
  function SpinWheelController() {
    _classCallCheck(this, SpinWheelController);
    this._lastWidth = SpinWheelController.breakpoint;
  }

  /**
   * Returns the last screen width recorded by the controller
   * @return int
   */
  return _createClass(SpinWheelController, [{
    key: "lastWidth",
    get: function get() {
      return this._lastWidth;
    }

    /**
     * Sets the lastWidth variable to a new value
     * @param width int
     */,
    set: function set(width) {
      this._lastWidth = width;
    }

    /**
     * Returns the breakpoint used to determine if optgroup should be added to selects.
     * @return int
     */
  }, {
    key: "optimizeSelects",
    value:
    /**
     * Optimizes the select elements based on breakpoint, if less than the breakpoint add the optgroup tag
     * @param {NodeList} selects
     * @param {int} width
     */
    function optimizeSelects(selects, width) {
      var movedAboveBreakpoint = width >= SpinWheelController.breakpoint && SpinWheelController.breakpoint > this.lastWidth;
      var movedBelowBreakpoint = width < SpinWheelController.breakpoint && SpinWheelController.breakpoint <= this.lastWidth;
      if (movedAboveBreakpoint) {
        selects.forEach(function (select) {
          SpinWheelController.removeOptgroup(select);
        });
      } else if (movedBelowBreakpoint) {
        selects.forEach(function (select) {
          SpinWheelController.addOptgroup(select);
        });
      }
      this.lastWidth = width;
    }
  }], [{
    key: "breakpoint",
    get: function get() {
      var smBreakpoint = 576; // equivalent to bootstrap's small breakpoint
      return smBreakpoint;
    }

    /**
     * Returns the hook class JavaScript methods use to find the optgroup
     * @return String
     */
  }, {
    key: "hookClass",
    get: function get() {
      return 'js-sw-only';
    }

    /**
     * Returns the optgroup markup used to manipulate the scroll wheel
     * @return String
     */
  }, {
    key: "optgroupMarkup",
    get: function get() {
      return '<optgroup hidden class="' + SpinWheelController.hookClass + '"></optgroup>';
    }

    /**
     * Add optgroup markup as the last child of the select element
     * @param {Node} select
     */
  }, {
    key: "addOptgroup",
    value: function addOptgroup(select) {
      select.insertAdjacentHTML('beforeend', SpinWheelController.optgroupMarkup);
    }

    /**
     * Removes the optgroup that controls the scoll wheel if present
     * @param {Node} select
     */
  }, {
    key: "removeOptgroup",
    value: function removeOptgroup(select) {
      // Check to ensure the last child in select element is the scroll wheel optgroup
      if (select.lastChild.classList.contains(SpinWheelController.hookClass)) {
        select.removeChild(select.lastChild);
      }
    }
  }]);
}(); // Export for Unit Testing
if (typeof exports !== 'undefined') {
  module.exports = SpinWheelController;
}

// IIFE
(function () {
  window.addEventListener('load', function () {
    // Checks if there is at least one select tag in the document
    if (document.querySelector('select') !== null) {
      var controller = new SpinWheelController();
      var selects = document.querySelectorAll('select');
      controller.optimizeSelects(selects, window.innerWidth);
      window.addEventListener('resize', function () {
        controller.optimizeSelects(selects, window.innerWidth);
      });
    }
  });
})();
/**
 * Static class used to hold data for the thank you page dataa
 */
var ThankYouPageData = /*#__PURE__*/function () {
  function ThankYouPageData() {
    _classCallCheck(this, ThankYouPageData);
  }
  return _createClass(ThankYouPageData, null, [{
    key: "transport",
    value: /* eslint-disable-line no-unused-vars */

    /**
     * Transports the id data from the cshtml to the DOM as data attributes for the form code to find.
     * @param {String} firstName id of input field with first name value
     * @param {String} lastName id of input field with last name value
     * @param {String} programName id of select field with program name value
     */
    function transport(firstName, lastName, programName) {
      // Grabs the nodes for the inputs to see if they exist
      var firstNameNode = document.getElementById(firstName);
      var lastNameNode = document.getElementById(lastName);
      var programNameNode = document.getElementById(programName);
      if (firstNameNode !== null && lastNameNode !== null && programNameNode !== null) {
        // Checks to make sure all fields have the same parent form, reject operation if any are not true
        var firstLastSameForm = firstNameNode.closest('form') === lastNameNode.closest('form');
        var firstProgSameForm = firstNameNode.closest('form') === programNameNode.closest('form');
        var lastProgSameForm = lastNameNode.closest('form') === programNameNode.closest('form');
        if (firstLastSameForm && firstProgSameForm && lastProgSameForm) {
          // Grabs the parent form
          var targetForm = firstNameNode.closest('form');

          // Add data attributes to the form storing the ids of the required fields.
          targetForm.setAttribute('data-tyc-fname', firstName);
          targetForm.setAttribute('data-tyc-lname', lastName);
          targetForm.setAttribute('data-tyc-pname', programName);
        }
      }
    }
  }]);
}(); // Export for Unit Testing
if (typeof exports !== 'undefined') {
  module.exports = ThankYouPageData;
}
// We need to add required to the `inqAppCitizenshipCountry` select
// if the INTL STUDENT radio button is true
var AppForm = /*#__PURE__*/function () {
  function AppForm() {
    _classCallCheck(this, AppForm);
  }
  return _createClass(AppForm, null, [{
    key: "addListeners",
    value: function addListeners() {
      window.addEventListener('load', function () {
        var countrySelect = document.getElementById('inqAppCitizenshipCountry');
        if (countrySelect !== null) {
          var visaRadioBtns = countrySelect.closest('.form-group').previousElementSibling.querySelectorAll('input[name="inqAppInternationalStudent"]');
          if (visaRadioBtns !== null) {
            var negativeOne = -1;
            Array.from(visaRadioBtns).forEach(function (btn) {
              btn.addEventListener('click', function (event) {
                if (event.target.value.toLowerCase().indexOf('yes') !== negativeOne) {
                  countrySelect.setAttribute('required', 'required');
                } else {
                  countrySelect.removeAttribute('required');
                }
              });
            });
          }
        }
      });
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = AppForm;
}
(function () {
  if (document.getElementById('inqAppCitizenshipCountry') !== undefined) {
    AppForm.addListeners();
  }
})();
var pfFiltersController = /*#__PURE__*/function () {
  /**
   * Constructor takes in current window width as parameter.
   * @param {int} windowWidth
   */
  function pfFiltersController(windowWidth) {
    _classCallCheck(this, pfFiltersController);
    this.windowWidth = windowWidth;
    this.breakpoint = 992;
    this.buttonQueryString = '.pf-filters .accordion-item:not(.location-item) .accordion-heading button';
    this.panelQueryString = '.pf-filters .accordion-item:not(.location-item) .accordion-panel';
  }

  /**
   * Adds listeners to trigger controller functions based on the event.
   */
  return _createClass(pfFiltersController, [{
    key: "bindListeners",
    value: function bindListeners() {
      var _this = this;
      // Listen on page load
      window.addEventListener('load', function () {
        _this.setView(window.innerWidth);
      });

      // Listen on window resize
      window.addEventListener("resize", function () {
        _this.checkWindowWidth(window.innerWidth);
      });
    }

    /**
     * Checks if window size has passed breakpoint, if so set the filter view and header content accordingly
     * @param {int} width
     */
  }, {
    key: "checkWindowWidth",
    value: function checkWindowWidth(width) {
      var mobileToDesktop = width >= this.breakpoint && this.windowWidth < this.breakpoint;
      var desktopToMobile = width < this.breakpoint && this.windowWidth >= this.breakpoint;
      if (mobileToDesktop || desktopToMobile) {
        this.setView(width);
      } else {
        this.windowWidth = width;
      }
    }

    /**
     * Based on given width, assigns whether filters should have mobile or desktop layout
     * @param {int} width
     */
  }, {
    key: "setView",
    value: function setView(width) {
      this.setAttributes(width < this.breakpoint);
      this.windowWidth = width;
    }

    /**
     * Sets the appropriate attributes for the filter accordions based on boolean parameter
     * @param {boolean} isMobile
     */
  }, {
    key: "setAttributes",
    value: function setAttributes(isMobile) {
      var buttons = document.querySelectorAll(this.buttonQueryString);
      buttons.forEach(function (button) {
        button.tabIndex = isMobile ? "0" : "-1";
        button.setAttribute('aria-expanded', isMobile ? 'false' : 'true');
      });
      var panels = document.querySelectorAll(this.panelQueryString);
      if (isMobile) {
        panels.forEach(function (panel) {
          panel.setAttribute('hidden', '');
        });
      } else {
        panels.forEach(function (panel) {
          panel.removeAttribute('hidden');
        });
      }
      var programs = document.querySelectorAll('.program-finder-results-table .program-name a');
      programs.forEach(function (program) {
        program.tabIndex = isMobile ? "0" : "-1";
      });
      var concentrations = document.querySelectorAll('.program-finder-results-table .program-concentration a');
      concentrations.forEach(function (concentration) {
        concentration.tabIndex = isMobile ? "0" : "-1";
      });
    }
  }]);
}(); // export as a module for unit testing
if (typeof exports !== 'undefined') {
  module.exports = pfFiltersController;
}

// Initialize and run in IIFE
(function () {
  var windowWidth = window.innerWidth;
  var controller = new pfFiltersController(windowWidth);
  controller.bindListeners();
})();
var FormStartFactory = /*#__PURE__*/function () {
  function FormStartFactory(formType, prepopulated, formSource) {
    _classCallCheck(this, FormStartFactory);
    this.formType = formType;
    this.prepopulated = prepopulated;
    this.formSource = formSource || "";
  }
  return _createClass(FormStartFactory, [{
    key: "create",
    value: function create() {
      return {
        'form': {
          'form_type': this.formType,
          'form_prepopulated': this.prepopulated,
          'form_source': this.formSource
        }
      };
    }
  }]);
}();
/* istanbul ignore next */
if (typeof exports !== 'undefined') {
  module.exports = FormStartFactory;
}
/* global FormStartFactory */
/* global GA4EventFactory */
/* global FormUtilities */
var FormsController = /*#__PURE__*/function () {
  function FormsController(form, ga4Event, formStart) {
    _classCallCheck(this, FormsController);
    this.form = form;
    this.ga4Event = ga4Event || new GA4EventFactory();
    this.formStart = formStart || new FormStartFactory();
  }
  return _createClass(FormsController, [{
    key: "FormStartEvent",
    value: function FormStartEvent() {
      var formData = this.formStart.create();
      this.ga4Event.create(formData);
    }
  }]);
}();
if (typeof exports !== 'undefined') {
  module.exports = FormsController;
}
window.addEventListener('load', function () {
  var form = document.querySelector('form[data-formtype]');
  if (!form) {
    return;
  }
  var formUtilities = new FormUtilities(form);
  var ga4Event = new GA4EventFactory('form_start');
  var formStart = new FormStartFactory(formUtilities.getFormType(), formUtilities.isPrepopulated(), formUtilities.getFormSource());
  var formscontroller = new FormsController(form, ga4Event, formStart);
  var formelements = formscontroller.form.elements;

  //we have to add this function here so we can add it to the addEventListener and then when called removeEventListener
  var _ga4FormStart = function ga4FormStart() {
    formscontroller.FormStartEvent();
    for (var i = 0; i < formelements.length; i++) {
      formelements[i].removeEventListener('blur', _ga4FormStart);
    }
  };
  for (var i = 0; i < formelements.length; i++) {
    formelements[i].addEventListener('blur', _ga4FormStart);
  }
});